<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="24">
                    <span class="title">司机名称:</span>
                    <!-- 搜索银行卡 -->
                    <el-input
                        v-model="search_data.real_name"
                        placeholder="请输入真实姓名"
                        class="handle-input mr10"
                        maxlength="19"
                        @keyup.enter.native="searchDriverWalletCashLists"
                    >
                    </el-input>
                </el-col>
            </el-row>

            <el-row class="head-search">
                <el-col :span="24" style="margin: 10px 0">
                    <span class="title">审核状态:</span>
                    <el-radio-group v-model="search_data.status" size="small">
                        <el-radio label="" border> 全部</el-radio>
                        <el-radio label="0" border>待审</el-radio>
                        <el-radio label="1" border>通过</el-radio>
                        <el-radio label="2" border>驳回</el-radio>
                    </el-radio-group>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchDriverWalletCashLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show">{{
                progress_show ? '导出中...' : '导出'
            }}</el-button>

            <!-- <el-button type="primary" @click="batchExecuteCashSubmit('1')">批量通过</el-button>
            <el-button type="danger" @click="batchExecuteCashSubmit('2')">批量拒绝</el-button> -->
        </div>
        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="selectionChange"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="申请详细时间:">
                                <span>{{ props.row.time.YmdHis }}</span>
                            </el-form-item>
                            <el-form-item label="审核详细时间:">
                                <span>{{ props.row.verify_time.YmdHis }}</span>
                            </el-form-item>
                        </div>

                        <el-form-item label="备注:">
                            <span>{{ props.row.remarks }}</span>
                        </el-form-item>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column type="selection" width="55"> </el-table-column>

            <el-table-column label="司机名称" width="150">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>司机编码: {{ scope.row.driver.driver_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333"
                                >{{ scope.row.driver.name }}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <!-- <el-table-column  label="银行卡号" width="200">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>唯一编码: {{ scope.row.driver_bank_card.driver_bank_card_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">
                                {{ scope.row.driver_bank_card.bank_card_no }}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column> -->
            <el-table-column label="手机号" width="200">
                <template slot-scope="scope">
                    <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">
                        {{ scope.row.phone }}
                    </el-tag>
                </template>
            </el-table-column>
            <!-- <el-table-column prop="pay_source" label="支付来源"> </el-table-column> -->

            <!-- <el-table-column prop="amount" label="提现金额"> </el-table-column> -->
            <el-table-column prop="balance" label="服务费余额"> </el-table-column>
            <!-- <el-table-column prop="connect" label="奖励金余额"> </el-table-column> -->

            <!-- <el-table-column prop="balance" label="钱包余额"> </el-table-column> -->

            <!-- <el-table-column prop="bond" label="保证金"> </el-table-column> -->

            <!-- <el-table-column prop="insurance" label="保险金"> </el-table-column> -->
            <el-table-column prop="rate_amount" label="手续费"> </el-table-column>

            <el-table-column prop="real_amount" label="提现到账金额"> </el-table-column>

            <el-table-column prop="time.Ymd" label="申请时间" min-width="100"> </el-table-column>

            <el-table-column prop="verify_time.Ymd" label="审核时间"> </el-table-column>

            <el-table-column label="审核状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}</el-tag
                    >
                </template>
            </el-table-column>

            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button
                        split-button
                        type="primary"
                        @click="
                            driverWalletCashToexamine_isShow = !driverWalletCashToexamine_isShow;
                            driverWalletCashToexamine_children = scope.row.driver_cash_code;
                        "
                        trigger="click"
                    >
                        离职审核
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 审核提现组件  -->
        <driverWalletCashToexamine
            :isShow="driverWalletCashToexamine_isShow"
            @onSubmit="driverWalletCashLists"
            :data="driverWalletCashToexamine_children"
        ></driverWalletCashToexamine>
    </div>
</template>

<script>
var _this;
import driverWalletCashToexamine from './driverWalletCashToexamine.vue';
export default {
    components: {
        driverWalletCashToexamine
    },
    data() {
        return {
            progress_show: false,

            excelData: [],

            excelHead: [],

            driver_code_array: '',

            // 传入子组件的数据
            driver_code_children: '',

            // 审核提现组件开关
            driverWalletCashToexamine_isShow: false,

            // 审核提现组件传值
            driverWalletCashToexamine_children: '',

            // 下拉搜索管理状态
            value_status_code: '',
            value_status_array: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                real_name: '',
                status: '',
                leave_status: 1
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.driverWalletCashLists();
    },

    methods: {
        batchExecuteCashSubmit(status) {
            _this
                .$post('/driver/batchExecuteCashSubmit', {
                    driver_cash_code: _this.driver_code_array,
                    status: status,
                    leave_status: 1
                })
                .then((res) => {
                    _this.$message.success('处理完成');
                })
                .catch((err) => {});
        },
        selectionChange(val) {
            console.log(val);

            let chengeArray = [];

            for (let i = 0; i < val.length; i++) {
                chengeArray.push(val[i].driver_cash_code);
            }
            _this.driver_code_array = JSON.stringify(chengeArray);

            console.log(_this.driver_code_array);
        },
        toExport() {
            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/driver/driverCash2LeaveListsCSV', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.$route.path == '/driverCash2LeaveLists') {
                        console.log(res.data);
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.result.length; i++) {
                            _this.excelData.push({
                                name: res.data.result[i].driver.name,
                                bank_card_no: res.data.result[i].driver_bank_card.bank_card_no,
                                amount: res.data.result[i].amount,
                                status: res.data.result[i].status.alias,
                                time: res.data.result[i].time.YmdHis,
                                verify_time: res.data.result[i].verify_time.Ymd,
                                id_card: res.data.result[i].id_card,
                                phone: res.data.result[i].phone,
                                balance: res.data.result[i].balance,
                                bond: res.data.result[i].bond,
                                insurance: res.data.result[i].insurance
                            });
                        }

                        if (res.data.page * res.data.limit < res.data.count) {
                            _this.search_data.page = res.data.page + 1;

                            // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '司机名称',
                '银行卡号',
                '身份证号',
                '电话',
                '提现金额',
                '钱包余额',
                '提现金额',
                '保证金',
                '保险金',
                '审核状态',
                '申请时间',
                '审核时间'
            ];
            const filterVal = [
                'name',
                'bank_card_no',
                'id_card',
                'phone',
                'amount',
                'balance',
                'bond',
                'insurance',
                'status',
                'time',
                'verify_time'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        searchDriverWalletCashLists() {
            _this.search_data.page = 1;
            _this.driverWalletCashLists();
        },
        // 搜索司机银行卡列表
        // driverWalletCashLists() {
        //   _this.$post(
        //       "/driver/driverCash2LeaveLists",
        //       _this.search_data,
        //       _this.search_rules
        //     )
        //     .then(res => {

        //       // 将请求的数据存放到表格数据数组中
        //       _this.tableData = res.data;
        //       _this.result_data = res;

        //       _this.value_status_array = res.data[0].status.select_array;

        //     }).catch((err) => {

        //     })
        // },
        driverWalletCashLists() {
            _this
                .$post('/driver/driverCashLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    _this.value_status_array = res.data[0].status.select_array;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverWalletCashLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

       
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
